// @ts-nocheck FIXME
import { useLegacyLabContext } from '@contexts/LegacyLabContext';
import Utils from '@legacy-components/components/DynamicUtils';
import NavigationLink from '@legacy-components/react/NavigationLink';

const HeaderLogo = (props) => {
  const lab = useLegacyLabContext();
  const logoLink = Utils.redirectToHomeBasedOnProductRoles.call(lab);
  return (
    <NavigationLink
      url={logoLink}
      id="tc__logo"
      className="tc-header__logo header__logo--v5"
    >
      <span className="tc-header__logo-caption">BetterLesson Lab</span>
    </NavigationLink>
  );
};

export default HeaderLogo;
